import React from "react";
import { useRouteMatch, useHistory } from 'react-router-dom'

import { Card, CardBody } from 'reactstrap'

// import { templatesList } from "../../constants";
import AssetsContractItem from "./AssetsContractItem";

const templatesList = [
    {
        id: '01',
        type: "ERC721",
        name: 'ERC721',
        blockchain: 'Ethereum',
        shortDescription:
            '',
        masterDescription:
            '',
        description:
            '',
        image: '../../assets/img/NFT_Icon.png',
        link: 'https://eips.ethereum.org/EIPS/eip-721',
    },
    {
        id: '02',
        type: "ERC721A",
        name: 'ERC721a',
        blockchain: 'Ethereum',
        shortDescription:
            '',
        masterDescription:
            '',
        description:
            '',
        image: '../../assets/img/NFT_Icon.png',
        link: 'https://eips.ethereum.org/EIPS/eip-721',
    },
    {
        id: '03',
        type: "ERC721PSI",
        name: 'ERC721psi',
        blockchain: 'Ethereum',
        shortDescription:
            '',
        masterDescription:
            '',
        description:
            '',
        image: '../../assets/img/NFT_Icon.png',
        link: 'https://eips.ethereum.org/EIPS/eip-721',
    },
    {
        id: '04',
        type: "ERC1155",
        name: 'ERC1155',
        blockchain: 'Ethereum',
        shortDescription:
            '',
        masterDescription:
            '',
        description:
            '',
        image: '../../assets/img/NFT_Icon.png',
        link: 'https://eips.ethereum.org/EIPS/eip-1155',
    },
    {
        id: '05',
        type: "ERC20",
        name: 'ERC20',
        blockchain: 'Ethereum',
        shortDescription:
            '',
        masterDescription:
            '',
        description:
            '',
        image: '../../assets/img/NFT_Icon.png',
        link: 'https://eips.ethereum.org/EIPS/eip-20',
    },
    // {
    //     id: '02',
    //     type: 'ERC1155',
    //     name: 'ERC 1155 NFT',
    //     blockchain: 'Ethereum',
    //     shortDescription:
    //         'Deploy your own ERC 1155 smart contract on the Ethereum blockchain',
    //     masterDescription:
    //         'Deploy master ERC 1155 smart contract on the Ethereum blockchain',
    //     description:
    //         'A standard interface for contracts that manage multiple token types. A single deployed contract may include any combination of fungible tokens, non-fungible tokens or other configurations (e.g. semi-fungible tokens).',
    //     image: '../../assets/img/NFT_Icon.png',
    //     link: 'https://eips.ethereum.org/EIPS/eip-1155',
    // },
    // {
    //     id: '03',
    //     type: 'ERC20',
    //     name: 'ERC 20',
    //     blockchain: 'Ethereum',
    //     shortDescription:
    //         'Deploy your own ERC 20 smart contract on the Ethereum blockchain',
    //     masterDescription:
    //         'Deploy master ERC 20 smart contract on the Ethereum blockchain',
    //     description:
    //         'A simple ERC 20 contract for all your needs',
    //     image: '../../assets/img/NFT_Icon.png',
    //     link: 'https://eips.ethereum.org/EIPS/eip-20',
    // },
];

export { templatesList };


export default function AssetsNavigation({ pathname }) {
    const { url } = useRouteMatch();
    const { push } = useHistory();

    return (
        <div className='sidebar-detached sidebar-left'>
            <div className='sidebar'>
                <div>
                    <Card>
                        <CardBody>
                            <div id='product-categories'>
                                <h5 className='filter-title'>Contracts</h5>
                                <ul className='list-unstyled categories-list'>
                                    {templatesList.map((item) => (
                                        <AssetsContractItem
                                            url={url}
                                            push={push}
                                            type={item.type}
                                            nameLink={item?.customName ?? item.name}
                                            key={item.id}
                                            pathname={pathname}
                                        />
                                    ))}
                                </ul>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
}
